import { styled } from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "ProfileButtonstyle__Container",
  componentId: "sc-14imogq-0"
})(["", ""], {
  "display": "flex",
  "width": "100px",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.25rem",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 14 45 / var(--tw-border-opacity, 1))",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "21px",
  "fontWeight": "400",
  "lineHeight": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(206 14 45 / var(--tw-text-opacity, 1))"
});
export const ImageWrapper = styled.div.withConfig({
  displayName: "ProfileButtonstyle__ImageWrapper",
  componentId: "sc-14imogq-1"
})(["", ""], {
  "height": "1.25rem !important",
  "width": "1.25rem !important"
});
export const Name = styled.div.withConfig({
  displayName: "ProfileButtonstyle__Name",
  componentId: "sc-14imogq-2"
})(["", ""], {
  "display": "inline-block !important",
  "height": "100% !important",
  "width": "50px",
  "overflow": "hidden",
  "textOverflow": "ellipsis"
});